<template>
  <div>
    <indirect-required-details :indirectId="indirectId"  /> 
    <vx-card :id="cardId" class="vs-con-loading__container">
      <card-header :title="$t(cardTitle)" v-model="params.search" @search="search" @close="close" />
      <indirect-required-table
        :data="data"
        @showDetails="showDetails"
        @loadMore="loadMore"
        @search="search"
      />
    </vx-card>
  </div>
</template>



<script>
import IndirectRequiredTable from '../tables/IndirectRequiredTable.vue'
import IndirectRequiredDetails from '../sidebards/IndirectRequiredDetails.vue'
import CardHeader from '../components/CardHeader.vue'
import dashboard from '@/http/requests/dashboard'

export default {
  name: 'indirect-required-card',
  components: {
    IndirectRequiredDetails,
    IndirectRequiredTable,
    CardHeader,
  },
  props: {
    // statusId: {
    //   type: [String, Number],
    //   required: true,
    // },
  },
  data() {
    return {
      cardTitle: 'indirect_required',
      cardId:'loading-indirect-required-card',
      data: [],
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
      },
      indirectId:''
    }
  },
  methods: {
    getData() {
      this.loading = true
      window.scrollTo(0,document.body.scrollHeight);
      dashboard
        .indirectList(this.params)
        .then((response) => {
          if (this.params.page === 1) {
            this.data = [...response.data.data]
          } else {
            this.data = [...this.data, ...response.data.data]
          }
          this.lastPage = response.data.last_page
          this.loading = false
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.loading = false
        })
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    showDetails(e) {
      this.indirectId = e
      this.$store.dispatch('toggleSidebar', 'sidebar-indirect-required-details')
    },
    close() {
      this.$emit('close')
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    }
  },
}
</script>

